import { useLang } from "@/App";
import { all, pick, seq } from "@/data/images";
import Hero from "@/components/Hero";
import Foto from "@/components/Foto";
import GaleriaGrid from "@/components/GaleriaGrid";
import { Reveal, Pretitulo, TituloSeccion, BtnPrimario } from "@/components/Reveal";

function BloqueGaleria({ config, carpeta, usadas, testid }) {
  const hero = pick(config.usar, 0) || all(config.usar)[0];
  const excl = hero ? [hero.split("/").pop()] : [];
  const fotos = [hero, ...seq(carpeta, 10, excl).filter((f) => f !== hero)].filter(Boolean).slice(0, 10);
  return (
    <section className="pb-20 md:pb-28" data-testid={testid}>
      <div className="mx-auto max-w-[1360px] px-6 md:px-10">
        <TituloSeccion pre={config.pre} titulo={config.titulo} />
        <GaleriaGrid fotos={fotos} columnas={5} testid={`${testid}-grid`} />
        <div className="mt-10 text-center">
          <BtnPrimario href="fotos/habitaciones" testid={`${testid}-ver-galeria-btn`}>VER GALERÍA</BtnPrimario>
        </div>
      </div>
    </section>
  );
}

export { BloqueGaleria };

export default function Habitaciones() {
  const { t, L } = useLang();
  const p = t.habitaciones;

  return (
    <div data-testid="pagina-habitaciones">
      <Hero pre={p.hero.pre} titulo={p.hero.titulo} fotos={[pick(p.hero.foto[0], 0) || all(p.hero.foto[0])[0]]} testid="hero-habitaciones" />

      {/* 2. Presentación */}
      <section className="py-20 md:py-28" data-testid="h-presentacion">
        <div className="mx-auto grid max-w-[1100px] items-center gap-12 px-6 md:px-10 lg:grid-cols-[5fr_6fr] lg:gap-20">
          <Reveal className="img-frame aspect-square w-full">
            <Foto src={pick(p.presentacion.foto[0], 0) || all(p.presentacion.foto[0])[0]} alt="" className="h-full w-full" testid="h-presentacion-foto" />
          </Reveal>
          <Reveal delay={0.12}>
            <Pretitulo center={false}>{p.presentacion.pre}</Pretitulo>
            <h2 className="mt-4 font-serif text-3xl font-light tracking-tight text-ink md:text-4xl">{p.presentacion.titulo}</h2>
            <p className="mt-7 max-w-xl text-[15.5px] leading-relaxed text-ink-soft">{p.presentacion.cuerpo}</p>
          </Reveal>
        </div>
      </section>

      {/* 3. Detalles: seis fotos + ficha técnica */}
      <section className="bg-ink py-20 md:py-28" data-testid="h-detalles">
        <div className="mx-auto max-w-[1300px] px-6 md:px-10">
          <TituloSeccion pre={p.detalles.pre} titulo={p.detalles.titulo} claro />
          <div className="grid gap-12 lg:grid-cols-[7fr_5fr] lg:gap-16">
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              {[1, 2, 3, 4, 5, 6].map((n, i) => (
                <Reveal key={n} delay={i * 0.05} className="img-frame aspect-[4/3] w-full">
                  <Foto src={pick(p.detalles.fotos.carpeta, n) || seq(p.detalles.fotos.carpeta, 6)[i]} alt="" className="h-full w-full" testid={`h-detalle-foto-${n}`} />
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.15}>
              <div className="border border-sand/15 bg-sand/5 p-7 md:p-9" data-testid="h-ficha-tecnica">
                <table className="ficha">
                  <tbody>
                    {p.detalles.ficha.map(([k, v]) => (
                      <tr key={k}>
                        <td className="!text-sand/90">{k}</td>
                        <td className="!text-sand/80">{v}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p className="mt-7 text-[11px] font-bold uppercase tracking-[0.24em] text-terra">{p.detalles.accesibilidadTitulo}</p>
                <p className="mt-3 text-sm leading-relaxed text-sand/65">{p.detalles.accesibilidad}</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* 4. Baños */}
      <section className="py-20 md:py-28" data-testid="h-banos">
        <div className="mx-auto grid max-w-[1300px] items-center gap-12 px-6 md:px-10 lg:grid-cols-[5fr_6fr] lg:gap-20">
          <Reveal>
            <Pretitulo center={false}>{p.banos.pre}</Pretitulo>
            <h2 className="mt-4 font-serif text-3xl font-light tracking-tight text-ink md:text-4xl">{p.banos.titulo}</h2>
            <p className="mt-7 text-[15px] leading-relaxed text-ink-soft">{p.banos.texto1}</p>
            <p className="mt-4 text-[15px] leading-relaxed text-ink-soft">{p.banos.texto2}</p>
            <p className="mt-4 text-[15px] leading-relaxed text-ink-soft">{p.banos.texto3}</p>
          </Reveal>
          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {[1, 2, 3, 4].map((n, i) => (
              <Reveal key={n} delay={i * 0.06} className="img-frame aspect-square w-full">
                <Foto src={pick(p.banos.fotos.carpeta, n) || seq(p.banos.fotos.carpeta, 4)[i]} alt="" className="h-full w-full" testid={`h-bano-foto-${n}`} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* 5. Galería */}
      <BloqueGaleria config={p.galeria} carpeta="habitaciones" testid="h-galeria" />
    </div>
  );
}